/*
 * File: Header.tsx
 * Project: a-a
 * File Created: Tuesday, 22nd October 2024 1:21:24 am
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Tuesday, 11th November 2025 7:55:42 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import { Box, Chip, Divider, Skeleton, Typography, useTheme } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import zeplinColor from '../../../theme/Color';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CustomPopOver from '../CustomPopOver/CustomPopOver';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { AuthService } from '../../../service/auth.service';
import RoutePaths from '../../../routes/RoutePaths';
import CustomCard from '../CustomCard/CustomCard';
import CustomModal from '../CustomModal/CustomModal';
import ResetPassword from '../../../pages/ResetPassword/ResetPassword';
import LoginReset from '../../featured/ResetPassword/LoginReset';
import { SFService } from '../../../service/SF.service';
import { useInput } from '../../../customHook/useInput';
import CustomTextField from '../CustomTextField/CustomTextField';
import validator from 'validator';
import { HuddleService } from '../../../service/huddle.service';
import CustomAlertContain from '../CustomAlert/CustomAlertContain';
import CustomAlert from '../CustomAlert/CustomAlert';
import CircularProgress from '@mui/material/CircularProgress';
import { ReactComponent as SettingIcon } from '../../../assets/settings.svg';
import { ReactComponent as LogoutIcon } from '../../../assets/logout-red.svg';
import styles from './Header.module.css';
import CustomSearch from '../CustomSearch/CustomSearch';
import CustomAutocomplete from '../CustomAutocomplete/CustomAutocomplete';
import { ZoomInfoService } from '../../../service/zoominfo.service';
import ZoominfoSearch from '../../featured/ZoomInfo/ZoominfoSearch/ZoominfoSearch';
const Header = () => {
  const theme = useTheme();
  const wait = useRef<any>(null);
  const userName = sessionStorage.getItem('user-name') || '';
  const userEmail = sessionStorage.getItem('current-user') || '';
  const location = useLocation();
  const details = location.pathname?.split('/');
  const linkInputRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate(); // This replaces useHistory in v6
  const [selectedSettings, setSelectedSettings] = useState('Profile');
  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const [anchorElLink, setAnchorElLink] = React.useState<HTMLDivElement | null>(null);
  const customLinkIdx = useRef<number | null>(null);
  const handleClickLink = (
    event: React.MouseEvent<HTMLDivElement>,
    type:
      | 'customLink'
      | 'facebook_profile_url'
      | 'instagram_profile_url'
      | 'twitter_profile_url'
      | 'linkedin_profile_url',
    edit = false,
    element = 0,
  ) => {
    // setLinkField(false);
    // console.log(
    //   event.altKey,
    //   event.type,
    //   (event.target as HTMLDivElement).getAttribute('alt'),
    //   event,
    // );

    if (linkField) {
      setLinkField((prev) => !prev);
      setLink('');
      setLinkPost({ customLink: '' });
    } else if (!linkField && (event.target as HTMLDivElement).getAttribute('alt') === 'option') {
      // setAnchorElLink(event.currentTarget);
      setLinkField(true);
      handleLinkField(type, edit, element);
    }
    customLinkIdx.current = type === 'customLink' ? element : null;

    // setTimeout(() => {
    //   linkInputRef.current?.scrollIntoView({
    //     behavior: 'smooth',
    //     block: 'end',
    //   });
    // }, 0);
    setTimeout(() => {
      if (linkInputRef?.current) {
        linkInputRef.current.scrollTop = linkInputRef.current.scrollHeight; // Scroll to the bottom
      }
    }, 0);
  };
  const handleDeleteCustomLink = async () => {
    try {
      setAnchorElLink(null);
      setLinkLoader(true);
      if (customLinkIdx?.current !== null) {
        const res = await HuddleService.saveProfile(userEmail, {
          // customLinkIdxToDelete: customLinkIdx.current,
          customLink: profile?.customLink.filter((val, ind) => ind !== customLinkIdx?.current),
        });
      }
      customLinkIdx.current = null;
      setLink('');
      setLinkPost({ customLink: '' });
      setAlert('Custom link removed successfully');
    } catch (err) {
      setAlert('Something went wrong');
    } finally {
      setLinkLoader(false);
    }
  };
  const openLink = Boolean(anchorElLink);
  const idLink = openLink ? 'simple-popover' : undefined;
  const handleGoBack = () => {
    sessionStorage.removeItem('currentTab');
    // Check if we're on a detail page (path structure: /{section}/{id})
    if (details.length > 2) {
      // Navigate back to the parent listing page
      navigate(`/${details[1]}`);
      return;
    }
    navigate(-1); // Go back to the previous page in history
  };
  const [alert, setAlert] = React.useState('');
  const token = sessionStorage.getItem('user-token') || '';
  const isMSLogin = sessionStorage.getItem('ms_login') || '';
  let accessToken: any = {};
  if (token) {
    accessToken = JSON.parse(token);
  }
  const [openModal, setOpenModal] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [profile, setProfile] = React.useState<{
    Address: {
      city: string;
      country: string;
      geocodeAccuracy: string;
      latitude: string;
      longitude: string;
      postalCode: string;
      state: string;
      street: string;
    };
    Email: string;
    MobilePhone: string;
    Name: string;
    Phone: string;
    Role: string;
    SF_Profile_URL: string;
    facebook_profile_url: string;
    instagram_profile_url: string;
    profile_image_url: string;
    twitter_profile_url: string;
    linkedin_profile_url: string;
    customLink: [string];
  }>({
    Address: {
      city: '',
      country: '',
      geocodeAccuracy: '',
      latitude: '',
      longitude: '',
      postalCode: '',
      state: '',
      street: '',
    },
    Email: '',
    MobilePhone: '',
    Name: '',
    Phone: '',
    Role: '',
    SF_Profile_URL: '',
    facebook_profile_url: '',
    instagram_profile_url: '',
    profile_image_url: '',
    twitter_profile_url: '',
    linkedin_profile_url: '',
    customLink: [''],
  });

  const handleOpen = () => {
    setOpenModal(true);
    setAnchorEl(null);
  };
  const handleClose = () => {
    setOpenModal(false);
  };

  const signOut = async () => {
    setLoading(true);
    try {
      const res = await AuthService.logout({
        accessToken: accessToken?.AccessToken,
        isMSLogin: isMSLogin ? true : false,
      });
      console.log(res);

      if (res?.microsoftLogoutUrl) {
        // const fullPath = '/' + res?.microsoftLogoutUrl;
        sessionStorage.clear();
        // sessionStorage.setItem('logoutOutUrl', res?.microsoftLogoutUrl);
        window.location.href = res?.microsoftLogoutUrl;
      } else {
        // sessionStorage.clear();
        sessionStorage.removeItem('loginExpiry');
        sessionStorage.removeItem('sf_path');
        sessionStorage.removeItem('refreshToken');
        sessionStorage.removeItem('user-name');
        sessionStorage.removeItem('user-token');

        sessionStorage.removeItem('currentTab');
        navigate(RoutePaths.Root);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const getProfileDetails = async () => {
    try {
      setLoading(true);
      const res = await SFService.getProfileDetails(userEmail);
      console.log(res);
      setProfile(res);
    } catch (err: any) {
      console.log(err);
      // setAlert(err?.response?.data?.error);
      setAlert('Something went wrong!');
    } finally {
      setLoading(false);
    }
  };
  const [searchZoomInfo, setSearchZoominfo] = useState<any[]>([]);
  const [searchValue, setSearchValue] = useState('');
  const [total, setTotal] = useState(0);
  const [openSettingsModal, setOpenSettingsModal] = React.useState(false);
  const [linkField, setLinkField] = React.useState(false);
  const [profileLoader, setProfileLoader] = React.useState(false);
  const [linkLoader, setLinkLoader] = React.useState(false);
  const handleOpenSettings = () => {
    setAnchorEl(null);
    setOpenSettingsModal(true);
  };
  const handleCloseSettings = () => {
    setOpenSettingsModal(false);
    setLinkField(false);
    clearLink();
  };
  useEffect(() => {
    console.log(selectedSettings);
    if (!profileLoader || !linkLoader) {
      getProfileDetails();
    }
  }, [profileLoader, linkLoader]);
  const openInput = () => {
    window.document.getElementById('attachment')?.click();
  };
  const uploadFile = async (data: any, contentType: string) => {
    // console.log(data);
    try {
      const res = await SFService.uploadFile(data, contentType);
      // console.log(res, data?.file);
    } catch (err) {
      // console.log(err);
    }
  };
  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setProfileLoader(true);
    try {
      if (event.target.files) {
        // console.log(event.target.files[0]?.name, Array.from(event.target.files));
        //  onDrop(Array.from(event.target.files));
        const getPresigned = await SFService.getPresigned(
          userEmail,
          event.target.files[0]?.type,
          event.target.files[0]?.name,
        );

        const upload = await uploadFile(
          { ...getPresigned.fileds, file: event.target?.files[0] },
          getPresigned.fileds['Content-Type'],
        );
        const saveProfile = await HuddleService.saveProfile(userEmail, {
          profile_image_url: `${getPresigned.url}${getPresigned.fileds.key}`,
        });
        // console.log(getPresigned, upload, saveProfile);
      }
      setAlert('Profile changed successfully');
    } catch (err: any) {
      console.log(err);
      setAlert('Something went wrong!');
    } finally {
      setProfileLoader(false);
    }
  };
  const handleRemoveDp = async () => {
    try {
      setProfileLoader(true);
      const saveProfile = await HuddleService.saveProfile(userEmail, {
        profile_image_url: '',
      });
      setAlert('User profile successfully removed.');
    } catch (err) {
      setAlert('Something went wrong.');
    } finally {
      setProfileLoader(false);
    }
  };
  const [linkPost, setLinkPost] = useState<
    | { customLink: string }
    | { facebook_profile_url: string }
    | {
        instagram_profile_url: string;
      }
    | { twitter_profile_url: string }
    | { linkedin_profile_url: string }
  >({ customLink: '' });
  console.log(
    linkPost[Object.keys(linkPost)[0] as keyof typeof linkPost],
    Object.keys(linkPost)[0],
  );
  const {
    handleChange: handleLinkChange,
    handleBlur: handleLinkBlur,
    clearInput: clearLink,
    value: link,
    invalid: invalidLink,
    didChange: didLinkChange,
    setValue: setLink,
  } = useInput(
    linkPost[Object.keys(linkPost)[0] as keyof typeof linkPost]
      ? linkPost[Object.keys(linkPost)[0] as keyof typeof linkPost]
      : '',
    validator?.isURL,
  );

  const handleLinkField = (
    type:
      | 'customLink'
      | 'facebook_profile_url'
      | 'instagram_profile_url'
      | 'twitter_profile_url'
      | 'linkedin_profile_url',
    edit = false,
    element = 0,
  ) => {
    if (type === 'customLink') {
      // setLinkField((prev) => !prev);
      // setLinkPost({ customLink: '' });
      if (edit) {
        setLinkPost({ customLink: profile?.customLink[element] });
        setLink(profile?.customLink[element]);
      } else {
        setLinkPost({ customLink: '' });
      }
    } else {
      setLink(profile[type as keyof typeof profile] as string);
      setLinkPost({
        [type]: profile[type as keyof typeof profile] ? profile[type as keyof typeof profile] : '',
      } as { customLink: string } | { facebook_profile_url: string } | { instagram_profile_url: string } | { twitter_profile_url: string } | { linkedin_profile_url: string });
    }
  };
  const suggestionZoominfoAPI = async (value: string) => {
    try {
      const res = await ZoomInfoService.searchZoominfo(value);
      console.log(res);
      // sessionStorage.setItem('search-zoominfo', JSON.stringify(res));

      setSearchZoominfo([
        ...res?.categories?.companies?.items.map((val: any) => ({
          ...val,
          group: 'Companies',
          label: val.name,
          Id: val?.id,
          Name: val?.name,
          avatar: val?.logo,
          followers: val?.website,
        })),
        ...res?.categories?.contacts?.items.map((val: any) => ({
          ...val,
          group: 'Contacts',
          label: val.name,
          Id: val?.id,
          Name: val?.name,
          avatar: val?.logo,
          followers: val?.website,
        })),
      ]);
      setTotal(res?.total);
      setSearchValue(value);
    } catch (err) {
      setAlert('Something went wrong');
    }
  };
  const handleSearch = async (e: React.SyntheticEvent, value: string) => {
    clearTimeout(wait.current);
    if (value) {
      const getSuggestion = setTimeout(() => suggestionZoominfoAPI(value), 1000);
      wait.current = getSuggestion;
    }
  };
  console.log(location);
  useEffect(() => {
    setLinkPost(
      (prev) =>
        ({ [Object.keys(prev)[0]]: link } as
          | { customLink: string }
          | { facebook_profile_url: string }
          | { instagram_profile_url: string }
          | { twitter_profile_url: string }
          | { linkedin_profile_url: string }),
    );
  }, [link]);
  const handleSave = async () => {
    try {
      setLinkLoader(true);
      if (Object.keys(linkPost)[0] === 'customLink') {
        const saveProfile = await HuddleService.saveProfile(userEmail, {
          customLink:
            Array.isArray(profile?.customLink) &&
            customLinkIdx?.current === null &&
            profile?.customLink?.length
              ? [...profile?.customLink, Object.values(linkPost)[0]]
              : Array.isArray(profile?.customLink) && profile?.customLink?.length
              ? [
                  ...profile?.customLink?.map((val, ind) =>
                    ind === customLinkIdx?.current ? Object.values(linkPost)[0] : val ? val : '',
                  ),
                ]
              : Array.isArray(profile?.customLink) && !profile?.customLink?.length
              ? [Object.values(linkPost)[0]]
              : [profile?.customLink, Object.values(linkPost)[0]],
        });
        customLinkIdx.current = null;
        setLinkField(false);
        setAlert('Link successfully saved');
        setLinkPost({ customLink: '' });
        setLink('');
      } else {
        const saveProfile = await HuddleService.saveProfile(userEmail, {
          ...linkPost,
        });
        setLinkField(false);
        setAlert('Link successfully saved');
      }
    } catch (err: any) {
      setAlert('Something went wrong');
    } finally {
      clearLink();
      setLinkLoader(false);
    }
  };
  const linkValue = linkPost[Object.keys(linkPost)[0] as keyof typeof linkPost] as string;
  console.log({ searchZoomInfo });
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          // width: '95%',
          // margin: 'auto',
          padding: { xs: '12px 16px', xl: '16px 24px' },
          alignItems: 'center',
          // height: { xs: '66px', xl: '96px' }, // Responsive height: 80px default, 96px for xl screens
        }}
      >
        {details.length > 2 ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, alignItems: 'flex-start' }}>
            <Box sx={{ display: 'flex', gap: '1px' }}>
              <Typography variant='label2' color={zeplinColor.Neutral8}>
                {details[1] === 'asana'
                  ? 'Projects/'
                  : `${details[1].charAt(0).toUpperCase()}${details[1].slice(
                      1,
                      // details[1].length - 1,
                    )} /`}
              </Typography>
              <Typography variant='label2'>
                {details[1] === 'asana'
                  ? 'Project Detail'
                  : details[1] === 'team'
                  ? 'Member Detail'
                  : `${details[1].charAt(0).toUpperCase()}${details[1].slice(
                      1,
                      details[1] === 'clients' ? details[1].length - 1 : details[1].length,
                    )} Detail`}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginLeft: '-8px',
                gap: '10px',
              }}
            >
              <img
                src={`/assets/back-icon.svg`}
                width='24px'
                height='24px'
                onClick={handleGoBack}
                style={{ cursor: 'pointer' }}
                alt='back-icon'
              />

              <Typography variant='responsiveHeading1'>
                {details[1] === 'asana'
                  ? 'Project Detail'
                  : details[1] === 'team'
                  ? 'Member Detail'
                  : `${details[1].charAt(0).toUpperCase()}${details[1].slice(
                      1,
                      details[1] === 'clients' ? details[1].length - 1 : details[1].length,
                    )} Detail`}
              </Typography>
            </Box>
          </Box>
        ) : (
          <Typography variant='responsiveHeading1' sx={{ flex: 1, alignItems: 'flex-start' }}>
            {details[1] === 'Asana'
              ? 'Project'
              : `${location.pathname.charAt(1).toUpperCase()}${location.pathname.slice(2)}`}
          </Typography>
        )}
        {location?.pathname?.includes('/zoominfo') && (
          <Box sx={{ flex: 2 }}>
            <CustomAutocomplete
              loading={loading}
              // chip={true}
              groupBy={true}
              searchIcon='/assets/Search.svg'
              required={false}
              fallback='/assets/zoominfo-fallback.svg'
              options={searchZoomInfo || []}
              getOptionLabel={(option: any) => (option?.Name ? option?.Name : '')}
              label={'Search for companies, contacts, industries, etc.'}
              handleDeleteItems={() => {}}
              selectedItems={[]}
              handleSelection={(value) => {
                console.log(value);
                navigate(`/zoominfo/${value?.Id}`);
              }}
              value={''}
              handleFilter={handleSearch}
              placeholder='Search for companies, contacts, industries, etc.'
              currentLength={searchZoomInfo?.length}
              totalLength={total}
              next={() => {
                suggestionZoominfoAPI(searchValue);
              }}
              multiple={false}
              inputBorder={50}
              outlineInputPadding={'5px'}
              key={location?.pathname || ''}
            />
            {/* <ZoominfoSearch /> */}
          </Box>
        )}
        <Box sx={{ display: 'flex', gap: '16px', flex: 1, justifyContent: 'flex-end' }}>
          {/* <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: 50,
            backgroundColor: zeplinColor.Neutral3,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src='/assets/setting.svg' />
        </Box>
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: 50,
            backgroundColor: zeplinColor.Neutral3,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src='/assets/notification.svg' />
        </Box> */}
          <Box
            sx={{
              // width: 178,
              height: 48,
              borderRadius: 50,
              backgroundColor: zeplinColor.Neutral3,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '16px',
              padding: '6px',
              cursor: 'pointer',
            }}
            onClick={handleClick}
          >
            <Box
              sx={{
                // width: 178,
                height: 48,
                borderRadius: 50,
                backgroundColor: zeplinColor.Neutral3,
                display: 'flex',
                // justifyContent: 'center',
                alignItems: 'center',
                gap: '8px',
                padding: '6px',
              }}
            >
              {/* <img src='/assets/dashboard-logo.svg' width={36} height={36} /> */}
              <Box
                sx={{
                  borderRadius: '100px',
                  padding: '10px',
                  width: { xs: '30px', xl: '36px' },
                  height: { xs: '30px', xl: '36px' },
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: profile?.profile_image_url ? 'transparent' : zeplinColor.Brand1,
                }}
              >
                {profile?.profile_image_url ? (
                  <img
                    className={styles['profile-img']}
                    src={profile?.profile_image_url}
                    alt='profile-img'
                    style={{ borderRadius: '100px', objectFit: 'fill' }}

                    // style={{ imageRendering: 'pixelated', filter: 'blur(0px)' }}
                  />
                ) : (
                  <Typography variant='responsiveLabel1' color={zeplinColor.Neutral1}>
                    {userName
                      ?.split(' ')
                      .map((value: any, index: number) =>
                        userName && (index === 0 || index === userName?.split(' ').length - 1)
                          ? value[0]
                          : '',
                      )}
                  </Typography>
                )}
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  //   alignItems: 'center',
                  //   gap: 4,
                }}
              >
                <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
                  {userName}
                </Typography>
                <Typography variant='responsiveCaption' color={zeplinColor.Neutral8}>
                  {profile?.Role}
                </Typography>
              </Box>
            </Box>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </Box>
        </Box>

        <CustomPopOver
          setAnchorEl={setAnchorEl}
          anchorEl={anchorEl}
          id={id}
          sx={{
            borderRadius: '14px',
            boxShadow: 'rgba(0, 0, 0, 0.15)',
            marginTop: '8px',
            marginRight: '0rem',
            zIndex: 999,
            // marginLeft: '-4rem',
          }}
        >
          <Box
            sx={{
              paddingTop: '24px',
              width: '210px',
              height: '192px',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Box
              sx={{
                display: 'flex',

                alignItems: 'center',
                gap: '8px',
                padding: '0px 16px',
                cursor: 'pointer',
              }}
            >
              {/* <img src='/assets/dashboard-logo.svg' width={36} height={36} /> */}
              <Box
                sx={{
                  borderRadius: '100px',
                  padding: '10px',
                  width: '36px',
                  height: '36px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: profile?.profile_image_url ? 'transparent' : zeplinColor.Brand1,
                }}
              >
                {profile?.profile_image_url ? (
                  <img
                    width={'36px'}
                    height={'36px'}
                    src={profile?.profile_image_url}
                    alt='profile-img'
                    style={{ borderRadius: '100px', objectFit: 'fill' }}
                    // style={{}}
                  />
                ) : (
                  <Typography variant='label1' color={zeplinColor.Neutral1}>
                    {userName
                      ?.split(' ')
                      .map((value: any, index: number) =>
                        userName && (index === 0 || index === userName?.split(' ').length - 1)
                          ? value[0]
                          : '',
                      )}
                  </Typography>
                )}
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  //   alignItems: 'center',
                  //   gap: 4,
                }}
              >
                <Typography variant='body3' color={zeplinColor.BasicBlack}>
                  {userName}
                </Typography>
                <Typography variant='caption' color={zeplinColor.Neutral8}>
                  {profile?.Role}
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                padding: '8px 0px',

                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
              }}
            >
              {' '}
              <Box
                sx={{
                  display: 'flex',
                  cursor: 'pointer',
                  gap: '16px',
                  padding: '16px',
                }}
                onClick={handleOpenSettings}
              >
                {/* <img src={`/assets/settings.svg`} width='18px' height='18px' alt='back-icon' /> */}
                <SettingIcon width='18px' height='18px' />
                <Typography variant='body3' color={zeplinColor.BasicBlack}>
                  Settings
                </Typography>
              </Box>
              <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5 }} />
              <Box
                sx={{
                  display: 'flex',
                  cursor: 'pointer',
                  gap: '16px',
                  padding: '16px',
                }}
                onClick={handleOpen}
              >
                {/* <img src={`/assets/logout-red.svg`} width='18px' height='18px' alt='back-icon' /> */}
                <LogoutIcon width='18px' height='18px' />
                <Typography variant='body3' color={zeplinColor.Error}>
                  Logout
                </Typography>
              </Box>
            </Box>
          </Box>
        </CustomPopOver>
        <CustomModal handleClose={handleClose} open={openModal}>
          <Box
            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}
          >
            <CustomCard
              styles={{
                borderRadius: '14px',
                padding: '24px',
                backgroundColor: zeplinColor.Neutral1,

                width: '312px',
                height: '183px',
                boxShadow: 'rgba(0, 0, 0, 0.15)',
                // display: 'flex',
                // flexDirection: 'column',
                // justifyContent: 'space-between',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                  gap: '32px',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '16px',
                  }}
                >
                  <Typography variant='heading3' color={zeplinColor.BasicBlack}>
                    Log Out?
                  </Typography>
                  <Typography variant='body3' color={zeplinColor.BasicBlack}>
                    Are you sure you want to log out?
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                    gap: '16px',
                  }}
                >
                  <Box onClick={handleClose}>
                    <CustomCard
                      styles={{
                        borderRadius: '14px',
                        padding: '14px 32px',
                        backgroundColor: zeplinColor.Neutral1,
                        border: `1px solid ${zeplinColor.BasicBlack}`,
                        cursor: 'pointer',
                        // width: '312px',
                        // height: '183px',

                        // display: 'flex',
                        // flexDirection: 'column',
                        // justifyContent: 'space-between',
                      }}
                      aria-role='button'
                      aria-disable={loading}
                    >
                      <Typography variant='buttonMedium' color={zeplinColor.BasicBlack}>
                        Cancel
                      </Typography>
                    </CustomCard>
                  </Box>
                  <Box onClick={signOut} sx={{ flex: 1 }}>
                    <CustomCard
                      styles={{
                        borderRadius: '14px',
                        padding: '14px 16px', // Reduced horizontal padding
                        backgroundColor: zeplinColor.BasicBlack,
                        cursor: 'pointer',
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        minWidth: '120px', // Ensure minimum width to fit both text states
                      }}
                      aria-role='button'
                      aria-disable={loading}
                    >
                      <Typography
                        variant='buttonMedium'
                        color={zeplinColor.Neutral1}
                        sx={{
                          whiteSpace: 'nowrap', // Prevent text wrapping
                          overflow: 'hidden', // Hide overflow
                          textOverflow: 'ellipsis', // Show ellipsis when overflowing
                          textAlign: 'center', // Center text
                          width: '100%', // Take full width
                        }}
                      >
                        {loading ? 'Logging out' : 'Log Out'}
                      </Typography>
                    </CustomCard>
                  </Box>
                </Box>
              </Box>
            </CustomCard>
            {/* {loading ? <CustomLoader /> : ''} */}
          </Box>
        </CustomModal>
        <CustomModal handleClose={handleCloseSettings} open={openSettingsModal}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh',
              // overflowY: 'scroll',
            }}
          >
            <CustomCard
              styles={{
                borderRadius: '14px',

                backgroundColor: zeplinColor.Neutral1,

                width: '810px',
                // height: '40rem',
                // overflowY: 'scroll',
                boxShadow: 'rgba(0, 0, 0, 0.15)',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  // height: '851px',
                  // overflowY: 'scroll',
                  flexDirection: 'column',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: '24px',
                  }}
                >
                  <Typography variant='responsiveHeading2'>Settings</Typography>
                  <img
                    src={'/assets/close-icon.svg'}
                    width={24}
                    height={24}
                    alt='close'
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      setOpenSettingsModal(false);
                      setLinkField(false);
                      clearLink();
                    }}
                  />
                </Box>
                <Divider
                  component='div'
                  sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }}
                />
                <Box style={{ display: 'flex', gap: '24px', padding: '24px' }}>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '8px',
                      flex: 1,
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        gap: '9px',
                        padding: '16px',
                        borderRadius: '16px',
                        backgroundColor:
                          selectedSettings === 'Profile'
                            ? zeplinColor.BasicBlack
                            : zeplinColor.Neutral1,
                        cursor: 'pointer',
                      }}
                      onClick={() => setSelectedSettings('Profile')}
                    >
                      <img
                        src={
                          selectedSettings === 'Profile'
                            ? `/assets/user-selected.svg`
                            : `/assets/profile.svg`
                        }
                        className={styles['settings-icon']}
                        alt='back-icon'
                      />
                      <Typography
                        variant='responsiveBody3'
                        color={
                          selectedSettings === 'Profile'
                            ? zeplinColor.Neutral1
                            : zeplinColor.BasicBlack
                        }
                      >
                        Profile
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: 'flex',
                        gap: '9px',
                        padding: '16px',
                        borderRadius: '16px',
                        backgroundColor:
                          selectedSettings === 'Account'
                            ? zeplinColor.BasicBlack
                            : zeplinColor.Neutral1,
                        cursor: 'pointer',
                      }}
                      onClick={() => setSelectedSettings('Account')}
                    >
                      <img
                        src={
                          selectedSettings === 'Account'
                            ? `/assets/account-selected.svg`
                            : `/assets/settings.svg`
                        }
                        className={styles['settings-icon']}
                        alt='back-icon'
                      />
                      <Typography
                        variant='responsiveBody3'
                        color={
                          selectedSettings === 'Account'
                            ? zeplinColor.Neutral1
                            : zeplinColor.BasicBlack
                        }
                      >
                        Account
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      flex: 3,
                      // height: '730px',
                      overflowY: 'scroll',
                    }}
                  >
                    {' '}
                    <CustomCard
                      styles={{
                        // height: '730px',
                        height: '75vh',
                        backgroundColor: zeplinColor.Neutral1,
                        borderWidth: `1px 1px 1px 1px`,
                        borderStyle: 'solid',
                        borderColor: `${zeplinColor.Neutral5}`,
                        borderRadius: '14px 14px 14px 14px',
                        overflowY: 'scroll',
                      }}
                    >
                      {selectedSettings === 'Profile' ? (
                        <Box
                          sx={{ overflowY: 'scroll', height: '100%', position: 'relative' }}
                          ref={linkInputRef}
                        >
                          <Box
                            sx={{
                              position: 'sticky',
                              top: 0,
                              backgroundColor: zeplinColor.Neutral1,
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                flex: 1,
                                padding: '24px',
                                // width: '100%',
                              }}
                            >
                              <Box sx={{ display: 'flex', gap: '16px', flex: 1 }}>
                                <Box
                                  sx={{
                                    width: { xs: '80px', xl: '100px' },
                                    height: { xs: '80px', xl: '100px' },
                                    borderRadius: '14px',
                                    //   border: '1px solid black',
                                    backgroundColor: !profile?.profile_image_url
                                      ? zeplinColor.Brand1
                                      : 'transparent',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    overflow: 'hidden',
                                    alignItems: 'center',
                                    position: 'relative',

                                    // ...(profileLoader && { filter: 'blur(30px)' }),
                                    '&:hover > img': { filter: 'blur(30px)' },
                                    // '&:hover > span': { opacity: 0.2 },
                                    '&:hover > div': {
                                      // Select the direct child div on hover
                                      // backdropFilter: 'blur(30px)',
                                      // filter: 'blur(10px)',
                                      display: 'flex',
                                      flexDirection: 'column',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                    },
                                  }}
                                >
                                  {profile?.profile_image_url ? (
                                    <img
                                      className={styles['settings-profile-img']}
                                      src={profile?.profile_image_url}
                                      alt='profile-img'
                                      style={{
                                        borderRadius: '14px',
                                        objectFit: 'fill',
                                        filter: profileLoader ? 'blur(30px)' : '',
                                      }}

                                      // style={{ imageRendering: 'pixelated',  }}
                                    />
                                  ) : (
                                    <Typography
                                      variant='responsiveDisplay4'
                                      sx={{
                                        color: zeplinColor.Neutral1,
                                        filter: profileLoader ? 'blur(30px)' : '',
                                        '& :hover': {
                                          filter: 'blur(30px)',
                                        },
                                      }}
                                    >
                                      {profile?.Name?.split(' ').map((value: any, index: number) =>
                                        profile?.Name &&
                                        (index === 0 ||
                                          index === profile?.Name?.split(' ').length - 1)
                                          ? value[0]
                                          : '',
                                      )}
                                    </Typography>
                                  )}
                                  {profileLoader ? (
                                    <Box
                                      sx={{
                                        position: 'absolute',
                                        width: '100%',
                                        height: '100%',
                                        display: profileLoader ? 'flex' : 'none',
                                        borderRadius: '14px',
                                        // '&:hover': {
                                        //   display: 'flex',
                                        //   flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        // },
                                      }}
                                    >
                                      {' '}
                                      <CircularProgress
                                        sx={{ color: zeplinColor.Neutral1 }}
                                        size={'18px'}
                                      />
                                    </Box>
                                  ) : (
                                    ''
                                  )}
                                  <Box
                                    sx={{
                                      position: 'absolute',
                                      width: '100%',
                                      height: '100%',
                                      display: 'none',
                                      borderRadius: '14px',
                                      // '&:hover': {
                                      //   display: 'flex',
                                      //   flexDirection: 'column',
                                      //   justifyContent: 'center',
                                      //   alignItems: 'center',
                                      // },
                                    }}
                                  >
                                    {profileLoader ? (
                                      ''
                                    ) : (
                                      <>
                                        <Box
                                          sx={{
                                            flex: 1,
                                            width: '100%',
                                            backgroundColor: '#00000026',
                                            display: 'flex',
                                            borderRadius: profile?.profile_image_url
                                              ? '14px 14px 0px 0px'
                                              : '14px 14px 14px 14px',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                          }}
                                          onClick={openInput}
                                        >
                                          <input
                                            type='file'
                                            accept='image/*'
                                            id='attachment'
                                            style={{ display: 'none' }}
                                            onChange={handleFileChange}
                                          />
                                          <Typography
                                            variant='buttonSmall'
                                            color={zeplinColor.Neutral1}
                                          >
                                            Change
                                          </Typography>
                                        </Box>
                                        {profile?.profile_image_url && (
                                          <Box
                                            sx={{
                                              flex: 1,
                                              width: '100%',
                                              backgroundColor: '#0000004D',
                                              display: 'flex',
                                              borderRadius: '0px 0px 14px 14px',
                                              justifyContent: 'center',
                                              alignItems: 'center',
                                              cursor: 'pointer',
                                            }}
                                            onClick={handleRemoveDp}
                                          >
                                            <Typography
                                              variant='buttonSmall'
                                              color={zeplinColor.Neutral1}
                                            >
                                              Delete
                                            </Typography>
                                          </Box>
                                        )}
                                      </>
                                    )}
                                  </Box>
                                </Box>
                                {/* <Box
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  // gap: '16px',
                                  // justifyContent: 'center',
                                }}
                              > */}
                                <Box
                                  sx={{
                                    display: 'flex',
                                    // alignItems: 'center',
                                    flexDirection: 'column',
                                    // justifyContent: 'center',
                                    gap: { xs: '10px', xl: '16px' },
                                  }}
                                >
                                  <Typography
                                    sx={{ fontSize: { xs: '30px', xl: '36px' }, fontWeight: '300' }}
                                    // color={zeplinColor.Neutral1}
                                  >
                                    {profile?.Name?.split(' ')[0]}
                                  </Typography>
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '4px',
                                    }}
                                  >
                                    <Chip
                                      label={
                                        <Typography
                                          variant='responsiveLabel1'
                                          color={zeplinColor.Neutral1}
                                          sx={{ display: 'flex', alignItems: 'center' }}
                                        >
                                          {profile?.Role || 'NA'}
                                        </Typography>
                                      }
                                      sx={{
                                        backgroundColor: zeplinColor.BasicBlack,
                                        padding: '5px 12px 5px 12px',
                                        borderRadius: '50px',
                                        // width: '47px',
                                        height: '24px',
                                        '&.MuiChip-root': {
                                          // flex: 1,
                                        },
                                      }}
                                    />

                                    {/* <Chip
                                    label={
                                      <Typography variant='label1' color={zeplinColor.Neutral1}>
                                        {'N/A'}
                                      </Typography>
                                    }
                                    sx={{
                                      backgroundColor: zeplinColor.Neutral10,
                                      padding: '5px 12px 5px 12px',
                                      borderRadius: '50px',
                                      // width: '47px',
                                      height: '24px',
                                      '&.MuiChip-root': {
                                        // flex: 1,
                                      },
                                    }}
                                  /> */}
                                  </Box>
                                </Box>
                                {/* </Box> */}
                              </Box>
                              <Link
                                to={`${profile?.SF_Profile_URL}`}
                                target='_blank'
                                rel='noopener noreferrer'
                                style={{ color: zeplinColor.Neutral1, textDecoration: 'none' }}
                              >
                                <CustomCard
                                  styles={{
                                    borderRadius: '50px',
                                    padding: '10px 10px 10px 16px',
                                    backgroundColor: zeplinColor.Neutral1,
                                    border: `1px solid ${zeplinColor.Neutral6}`,
                                    display: 'flex',
                                    gap: '8px',
                                    // flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    cursor: 'pointer',
                                    height: '48px',
                                  }}
                                >
                                  <Typography
                                    variant='responsiveBody3'
                                    color={zeplinColor.BasicBlack}
                                  >
                                    Salesforce
                                  </Typography>
                                  <img src='/assets/arrow-link.svg' width={20} height={20} />
                                </CustomCard>
                              </Link>
                            </Box>
                            <Divider
                              component='div'
                              sx={{ borderColor: zeplinColor.Neutral5, position: 'sticky' }}
                            />
                          </Box>
                          <Box sx={{ padding: '24px' }}>
                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: { xs: '22px', xl: '32px' },
                              }}
                            >
                              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                                <Typography variant='responsiveHeading2'>
                                  Personal Details
                                </Typography>
                                <Box sx={{ display: 'flex', gap: '48px' }}>
                                  <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                                    {/* <img
                src='/assets/account-name.svg'
                width={20}
                height={20}
                style={{ objectFit: 'fill' }}
              /> */}
                                    <Typography
                                      variant='responsiveBody2'
                                      color={zeplinColor.Neutral8}
                                      sx={{ flex: 1 }}
                                    >
                                      Name
                                    </Typography>

                                    {loading ? (
                                      <Skeleton
                                        variant='text'
                                        sx={{
                                          fontSize: theme.typography.body2,
                                          flex: 1,
                                          // Optionally adjust other styles here
                                        }}
                                      />
                                    ) : (
                                      <Typography variant='responsiveBody2' sx={{ flex: 3 }}>
                                        {profile?.Name}
                                      </Typography>
                                    )}
                                  </Box>
                                </Box>

                                <Box sx={{ display: 'flex', gap: '48px' }}>
                                  <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                                    {/* <img
                src='/assets/relationship.svg'
                width={20}
                height={20}
                style={{ objectFit: 'fill' }}
              /> */}
                                    <Typography
                                      variant='responsiveBody2'
                                      color={zeplinColor.Neutral8}
                                      sx={{ flex: 1 }}
                                    >
                                      Role
                                    </Typography>

                                    {loading ? (
                                      <Skeleton
                                        variant='text'
                                        sx={{
                                          fontSize: theme.typography.body2,
                                          flex: 1,
                                          // Optionally adjust other styles here
                                        }}
                                      />
                                    ) : (
                                      <Box sx={{ flex: 3, display: 'flex', gap: '8px' }}>
                                        <Chip
                                          label={
                                            <Typography
                                              variant='responsiveLabel1'
                                              color={zeplinColor.Neutral1}
                                            >
                                              {profile?.Role}
                                            </Typography>
                                          }
                                          sx={{
                                            backgroundColor: zeplinColor.BasicBlack,
                                            padding: '5px 12px 5px 12px',
                                            borderRadius: '50px',
                                            // width: '47px',
                                            height: '24px',
                                            '&.MuiChip-root': {
                                              // flex: 1,
                                            },
                                          }}
                                        />

                                        {/* <Chip
                                      label={
                                        <Typography variant='label1' color={zeplinColor.Neutral1}>
                                          N/A
                                        </Typography>
                                      }
                                      sx={{
                                        backgroundColor: zeplinColor.BasicBlack,
                                        padding: '5px 12px 5px 12px',
                                        borderRadius: '50px',
                                        // width: '47px',
                                        height: '24px',
                                        '&.MuiChip-root': {
                                          // flex: 1,
                                        },
                                      }}
                                    /> */}
                                      </Box>
                                    )}
                                  </Box>
                                </Box>
                              </Box>
                              <Typography variant='responsiveHeading2'>Contact Details</Typography>
                              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                                <Box sx={{ display: 'flex', gap: '48px' }}>
                                  <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                                    {/* <img src='/assets/mobile.svg' width={20} height={20} style={{ objectFit: 'fill' }} /> */}
                                    <Typography
                                      variant='responsiveBody2'
                                      color={zeplinColor.Neutral8}
                                      sx={{ flex: 1 }}
                                    >
                                      Mobile
                                    </Typography>

                                    {loading ? (
                                      <Skeleton
                                        variant='text'
                                        sx={{
                                          fontSize: theme.typography.body2,
                                          flex: 1,
                                          // Optionally adjust other styles here
                                        }}
                                      />
                                    ) : (
                                      <Typography variant='responsiveBody2' sx={{ flex: 3 }}>
                                        {profile.MobilePhone}
                                      </Typography>
                                    )}
                                  </Box>
                                </Box>
                                <Box sx={{ display: 'flex', gap: '48px' }}>
                                  <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                                    {/* <img src='/assets/mobile.svg' width={20} height={20} style={{ objectFit: 'fill' }} /> */}
                                    <Typography
                                      variant='responsiveBody2'
                                      color={zeplinColor.Neutral8}
                                      sx={{ flex: 1 }}
                                    >
                                      Phone
                                    </Typography>

                                    {loading ? (
                                      <Skeleton
                                        variant='text'
                                        sx={{
                                          fontSize: theme.typography.body2,
                                          flex: 1,
                                          // Optionally adjust other styles here
                                        }}
                                      />
                                    ) : (
                                      <Typography variant='responsiveBody2' sx={{ flex: 3 }}>
                                        {profile?.Phone}
                                      </Typography>
                                    )}
                                  </Box>
                                </Box>
                                <Box sx={{ display: 'flex', gap: '48px' }}>
                                  <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                                    {/* <img src='/assets/email.svg' width={20} height={20} style={{ objectFit: 'fill' }} /> */}
                                    <Typography
                                      variant='responsiveBody2'
                                      color={zeplinColor.Neutral8}
                                      sx={{ flex: 1 }}
                                    >
                                      Email
                                    </Typography>

                                    {loading ? (
                                      <Skeleton
                                        variant='text'
                                        sx={{
                                          fontSize: theme.typography.body2,
                                          flex: 1,
                                          // Optionally adjust other styles here
                                        }}
                                      />
                                    ) : (
                                      <a
                                        href={`mailto:${profile?.Email}`}
                                        target='_blank'
                                        rel='noopener noreferrer'
                                        style={{
                                          color: zeplinColor.Brand1,
                                          textDecoration: 'none',
                                          flex: 3,
                                        }}
                                        className={styles['email-link']}
                                      >
                                        {/* <Typography variant='body2' sx={{ flex: 3 }}> */}
                                        {profile?.Email}
                                        {/* </Typography> */}
                                      </a>
                                    )}
                                  </Box>
                                </Box>

                                <Box sx={{ display: 'flex', gap: '48px' }}>
                                  <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                                    <Typography
                                      variant='responsiveBody2'
                                      color={zeplinColor.Neutral8}
                                      sx={{ flex: 1 }}
                                    >
                                      Address
                                    </Typography>

                                    {loading ? (
                                      <Skeleton
                                        variant='text'
                                        sx={{
                                          fontSize: theme.typography.body2,
                                          flex: 1,
                                          // Optionally adjust other styles here
                                        }}
                                      />
                                    ) : (
                                      <Typography
                                        variant='responsiveBody2'
                                        sx={{ flex: 3, textWrap: 'nowrap', whiteSpace: 'nowrap' }}
                                      >
                                        {`${
                                          profile?.Address?.street ? profile?.Address?.street : ''
                                        }`}
                                        {`${
                                          profile?.Address?.city
                                            ? ', ' + profile?.Address?.city
                                            : ''
                                        }`}
                                        {`${
                                          profile?.Address?.state
                                            ? ', ' + profile?.Address?.state
                                            : ''
                                        }`}
                                        {`${
                                          profile?.Address?.country
                                            ? ', ' + profile?.Address?.country
                                            : ''
                                        }`}
                                        {`${
                                          profile?.Address?.postalCode
                                            ? ', ' + profile?.Address?.postalCode
                                            : ''
                                        }`}
                                      </Typography>
                                    )}
                                  </Box>
                                </Box>
                              </Box>

                              <Typography variant='responsiveHeading2'>Links</Typography>
                              <Box
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: { xs: '20px', xl: '24px' },
                                }}
                              >
                                <Box sx={{ display: 'flex', gap: { xs: '12px', xl: '16px' } }}>
                                  {/* <Link
                                  to={`${profile?.facebook_profile_url}`}
                                  target='_blank'
                                  rel='noopener noreferrer'
                                  style={{ color: zeplinColor.Neutral1, textDecoration: 'none' }}
                                  onClick={(e) =>
                                    !profile?.facebook_profile_url && e.preventDefault()
                                  }
                                > */}

                                  <Box
                                    sx={{
                                      position: 'relative',
                                      '&:hover > .hover-image': {
                                        display: 'flex', // Show the second image on hover
                                      },
                                    }}
                                    onClick={(e) => handleClickLink(e, 'linkedin_profile_url')}
                                  >
                                    <Link
                                      to={`${profile?.linkedin_profile_url}`}
                                      target='_blank'
                                      rel='noopener noreferrer'
                                      style={{
                                        color: zeplinColor.Neutral1,
                                        textDecoration: 'none',
                                      }}
                                      onClick={(e) =>
                                        !profile?.facebook_profile_url && e.preventDefault()
                                      }
                                    >
                                      <img
                                        className={styles['link-icon']}
                                        src={'/assets/linkedin-link.png'}
                                        alt='link'
                                        style={{ objectFit: 'fill', cursor: 'pointer' }}
                                        // onClick={(e) => handleClickLink(e, 'instagram_profile_url')}
                                      />
                                    </Link>
                                    <Box
                                      className='hover-image'
                                      sx={{
                                        position: 'absolute',
                                        top: { xs: '-0.4rem', xl: '-0.6rem' },
                                        right: { xs: '-0.6rem', xl: '-1rem' },
                                        display: 'none',
                                        // '&:hover': {
                                        //   display: 'none', // Show the second image on hover
                                        // },
                                      }}
                                    >
                                      <img
                                        className={styles['edit-icon']}
                                        src={'/assets/edit-link.png'}
                                        alt='option'
                                        style={{
                                          objectFit: 'fill',
                                          cursor: 'pointer',
                                        }}
                                      />
                                    </Box>
                                  </Box>
                                  {/* </Link> */}
                                  <Box
                                    sx={{
                                      position: 'relative',
                                      '&:hover > .hover-image': {
                                        display: 'flex', // Show the second image on hover
                                      },
                                    }}
                                    onClick={(e) => handleClickLink(e, 'instagram_profile_url')}
                                  >
                                    <Link
                                      to={`${profile?.instagram_profile_url}`}
                                      target='_blank'
                                      rel='noopener noreferrer'
                                      style={{
                                        color: zeplinColor.Neutral1,
                                        textDecoration: 'none',
                                      }}
                                      onClick={(e) =>
                                        !profile?.facebook_profile_url && e.preventDefault()
                                      }
                                    >
                                      <img
                                        className={styles['link-icon']}
                                        src={'/assets/instagram-link.png'}
                                        alt='link'
                                        style={{ objectFit: 'fill', cursor: 'pointer' }}
                                      />
                                    </Link>
                                    <Box
                                      className='hover-image'
                                      sx={{
                                        position: 'absolute',
                                        top: { xs: '-0.4rem', xl: '-0.6rem' },
                                        right: { xs: '-0.6rem', xl: '-1rem' },
                                        display: 'none',
                                        // '&:hover': {
                                        //   display: 'none', // Show the second image on hover
                                        // },
                                      }}
                                      // onClick={(e) => handleClickLink(e, 'instagram_profile_url')}
                                    >
                                      <img
                                        className={styles['edit-icon']}
                                        src={'/assets/edit-link.png'}
                                        alt='option'
                                        style={{
                                          objectFit: 'fill',
                                          cursor: 'pointer',
                                        }}
                                      />
                                    </Box>
                                  </Box>
                                  <Box
                                    sx={{
                                      position: 'relative',
                                      '&:hover > .hover-image': {
                                        display: 'flex', // Show the second image on hover
                                      },
                                    }}
                                    onClick={(e) => handleClickLink(e, 'twitter_profile_url')}
                                  >
                                    <Link
                                      to={`${profile?.twitter_profile_url}`}
                                      target='_blank'
                                      rel='noopener noreferrer'
                                      style={{
                                        color: zeplinColor.Neutral1,
                                        textDecoration: 'none',
                                      }}
                                      onClick={(e) =>
                                        !profile?.facebook_profile_url && e.preventDefault()
                                      }
                                    >
                                      <img
                                        className={styles['link-icon']}
                                        src={'/assets/x-link.png'}
                                        alt='link'
                                        style={{ objectFit: 'fill', cursor: 'pointer' }}
                                      />
                                    </Link>
                                    <Box
                                      className='hover-image'
                                      sx={{
                                        position: 'absolute',
                                        top: { xs: '-0.4rem', xl: '-0.6rem' },
                                        right: { xs: '-0.6rem', xl: '-1rem' },
                                        display: 'none',
                                        // '&:hover': {
                                        //   display: 'none', // Show the second image on hover
                                        // },
                                      }}
                                    >
                                      <img
                                        className={styles['edit-icon']}
                                        src={'/assets/edit-link.png'}
                                        alt='option'
                                        style={{
                                          objectFit: 'fill',
                                          cursor: 'pointer',
                                        }}
                                      />
                                    </Box>
                                  </Box>
                                  <Box
                                    sx={{
                                      position: 'relative',
                                      '&:hover > .hover-image': {
                                        display: 'flex', // Show the second image on hover
                                      },
                                    }}
                                    onClick={(e) => handleClickLink(e, 'facebook_profile_url')}
                                  >
                                    <Link
                                      to={`${profile?.facebook_profile_url}`}
                                      target='_blank'
                                      rel='noopener noreferrer'
                                      style={{
                                        color: zeplinColor.Neutral1,
                                        textDecoration: 'none',
                                      }}
                                      onClick={(e) =>
                                        !profile?.facebook_profile_url && e.preventDefault()
                                      }
                                    >
                                      <img
                                        className={styles['link-icon']}
                                        src={'/assets/facebook-link.png'}
                                        alt='link'
                                        style={{ objectFit: 'fill', cursor: 'pointer' }}
                                        // onClick={(e) => handleClickLink(e, 'facebook_profile_url')}
                                      />
                                    </Link>
                                    <Box
                                      className='hover-image'
                                      sx={{
                                        position: 'absolute',
                                        top: { xs: '-0.4rem', xl: '-0.6rem' },
                                        right: { xs: '-0.6rem', xl: '-1rem' },
                                        display: 'none',
                                        // '&:hover': {
                                        //   display: 'none', // Show the second image on hover
                                        // },
                                      }}
                                    >
                                      <img
                                        className={styles['edit-icon']}
                                        src={'/assets/edit-link.png'}
                                        alt='option'
                                        style={{
                                          objectFit: 'fill',
                                          cursor: 'pointer',
                                        }}
                                      />
                                    </Box>
                                  </Box>
                                  {Array.isArray(profile?.customLink) && profile?.customLink?.length
                                    ? profile?.customLink?.map((val, ind) => (
                                        <Box
                                          sx={{
                                            position: 'relative',
                                            '&:hover > .hover-image': {
                                              display: 'flex', // Show the second image on hover
                                            },
                                          }}
                                          onClick={(e) =>
                                            handleClickLink(e, 'customLink', true, ind)
                                          }
                                        >
                                          <Link
                                            to={`${val}`}
                                            target='_blank'
                                            rel='noopener noreferrer'
                                            style={{
                                              color: zeplinColor.Neutral1,
                                              textDecoration: 'none',
                                            }}
                                            onClick={(e) =>
                                              !profile?.facebook_profile_url && e.preventDefault()
                                            }
                                          >
                                            <Box
                                              sx={{
                                                width: { xs: '26px', xl: '32px' },
                                                height: { xs: '26px', xl: '32px' },
                                                borderRadius: '8px',
                                                padding: '7px',
                                                border: `1px solid none`,
                                                backgroundColor: zeplinColor.Brand1,
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                cursor: 'pointer',
                                              }}
                                              // onClick={(e) =>
                                              //   handleClickLink(e, 'customLink', true, ind)
                                              // }
                                            >
                                              <img
                                                className={styles['settings-icon']}
                                                src={'/assets/custom-link.svg'}
                                                alt='link'
                                                style={{ objectFit: 'fill' }}
                                              />
                                            </Box>
                                          </Link>
                                          <Box
                                            className='hover-image'
                                            sx={{
                                              position: 'absolute',
                                              top: { xs: '-0.4rem', xl: '-0.6rem' },
                                              right: { xs: '-0.6rem', xl: '-1rem' },
                                              display: 'none',
                                              // '&:hover': {
                                              //   display: 'none', // Show the second image on hover
                                              // },
                                            }}
                                          >
                                            <img
                                              className={styles['edit-link']}
                                              src={'/assets/edit-link.png'}
                                              alt='option'
                                              style={{
                                                objectFit: 'fill',
                                                cursor: 'pointer',
                                              }}
                                            />
                                          </Box>
                                        </Box>
                                      ))
                                    : ''}
                                  <Box
                                    sx={{
                                      width: { xs: '28px', xl: '32px' },
                                      height: { xs: '28px', xl: '32px' },
                                      borderRadius: '8px',
                                      padding: '7px',
                                      border: `1px solid ${zeplinColor.Neutral6}`,
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      cursor: 'pointer',
                                    }}
                                    onClick={() => {
                                      handleLinkField('customLink', false);
                                      setLinkField((prev) => !prev);
                                      if (linkField) {
                                        setLink('');
                                        setLinkPost({ customLink: '' });
                                      }
                                      // setTimeout(() => {
                                      //   linkInputRef?.current?.scrollIntoView({
                                      //     behavior: 'smooth',
                                      //     block: 'end',
                                      //   });
                                      // }, 0);
                                      setTimeout(() => {
                                        if (linkInputRef?.current) {
                                          linkInputRef.current.scrollTop =
                                            linkInputRef.current.scrollHeight; // Scroll to the bottom
                                        }
                                      }, 0);
                                    }}
                                  >
                                    <img
                                      width={'12px'}
                                      height={'12px'}
                                      src={'/assets/add.svg'}
                                      alt='link'
                                      style={{ objectFit: 'fill' }}
                                    />
                                  </Box>
                                </Box>
                                {linkField && (
                                  <Box
                                    sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}
                                    // ref={linkInputRef}
                                  >
                                    <CustomTextField
                                      style={{ width: '100%' }}
                                      onBlur={handleLinkBlur}
                                      onChange={handleLinkChange}
                                      name='Link'
                                      text={link}
                                      error={
                                        invalidLink &&
                                        didLinkChange &&
                                        !linkLoader &&
                                        link &&
                                        linkPost[Object.keys(linkPost)[0] as keyof typeof linkPost]
                                          ? 'Please enter valid link'
                                          : ''
                                      }
                                      label={'Link'}
                                      type='text'
                                      tabindex={1}
                                      close={link ? true : false}
                                      handleClear={() => {
                                        clearLink();
                                      }}
                                      // required
                                    />
                                    <Box
                                      sx={{
                                        display: 'flex',

                                        gap: '16px',
                                      }}
                                    >
                                      <Box
                                        onClick={() => {
                                          !linkLoader && handleSave();
                                        }}
                                      >
                                        <CustomCard
                                          styles={{
                                            borderRadius: '14px',
                                            padding: { xs: '10px 28px', xl: '14px 32px' },
                                            backgroundColor:
                                              (link &&
                                                !invalidLink &&
                                                !linkLoader &&
                                                ((customLinkIdx?.current === null &&
                                                  linkValue !==
                                                    profile[
                                                      Object.keys(
                                                        linkPost,
                                                      )[0] as keyof typeof profile
                                                    ]) ||
                                                  (customLinkIdx?.current !== null &&
                                                    linkValue !==
                                                      profile?.customLink[
                                                        customLinkIdx?.current
                                                      ]))) ||
                                              (linkPost[
                                                Object.keys(linkPost)[0] as keyof typeof linkPost
                                              ] &&
                                                !linkLoader &&
                                                ((customLinkIdx?.current === null &&
                                                  linkValue !==
                                                    profile[
                                                      Object.keys(
                                                        linkPost,
                                                      )[0] as keyof typeof profile
                                                    ]) ||
                                                  (customLinkIdx?.current !== null &&
                                                    linkValue !==
                                                      profile?.customLink[customLinkIdx?.current])))
                                                ? zeplinColor.Brand1
                                                : zeplinColor.Neutral5,
                                            cursor: 'pointer',

                                            // border: `1px solid ${zeplinColor.BasicBlack}`,
                                            // width: '312px',
                                            // height: '183px',

                                            // display: 'flex',
                                            // flexDirection: 'column',
                                            // justifyContent: 'space-between',
                                          }}
                                          aria-role='button'
                                          aria-disable={loading}
                                        >
                                          <Typography
                                            variant='responsiveButtonMedium'
                                            color={
                                              (link &&
                                                !invalidLink &&
                                                !linkLoader &&
                                                ((customLinkIdx?.current === null &&
                                                  linkValue !==
                                                    profile[
                                                      Object.keys(
                                                        linkPost,
                                                      )[0] as keyof typeof profile
                                                    ]) ||
                                                  (customLinkIdx?.current !== null &&
                                                    linkValue !==
                                                      profile?.customLink[
                                                        customLinkIdx?.current
                                                      ]))) ||
                                              (linkPost[
                                                Object.keys(linkPost)[0] as keyof typeof linkPost
                                              ] &&
                                                !linkLoader &&
                                                ((customLinkIdx?.current === null &&
                                                  linkValue !==
                                                    profile[
                                                      Object.keys(
                                                        linkPost,
                                                      )[0] as keyof typeof profile
                                                    ]) ||
                                                  (customLinkIdx?.current !== null &&
                                                    linkValue !==
                                                      profile?.customLink[customLinkIdx?.current])))
                                                ? zeplinColor.Neutral1
                                                : zeplinColor.Neutral8
                                            }
                                            sx={{ whiteSpace: 'nowrap' }}
                                          >
                                            {linkLoader ? 'Saving link' : 'Save'}
                                          </Typography>
                                        </CustomCard>
                                      </Box>
                                      <Box
                                        onClick={() => {
                                          setLinkField(false);
                                          setLink('');
                                          setLinkPost({ customLink: '' });
                                          clearLink();
                                        }}
                                      >
                                        <CustomCard
                                          styles={{
                                            borderRadius: '14px',
                                            padding: { xs: '10px 28px', xl: '14px 32px' },
                                            backgroundColor: zeplinColor.Neutral1,
                                            border: `1px solid ${zeplinColor.BasicBlack}`,
                                            cursor: 'pointer',
                                            // width: '312px',
                                            // height: '183px',

                                            // display: 'flex',
                                            // flexDirection: 'column',
                                            // justifyContent: 'space-between',
                                          }}
                                          aria-role='button'
                                          aria-disable={loading}
                                        >
                                          <Typography
                                            variant='responsiveButtonMedium'
                                            color={zeplinColor.BasicBlack}
                                          >
                                            Cancel
                                          </Typography>
                                        </CustomCard>
                                      </Box>
                                    </Box>
                                  </Box>
                                )}
                              </Box>
                              <CustomPopOver
                                setAnchorEl={setAnchorElLink}
                                anchorEl={anchorElLink}
                                id={idLink}
                                sx={{
                                  borderRadius: '14px',
                                  boxShadow: 'rgba(0, 0, 0, 0.15)',
                                  marginTop: '0.1rem',
                                  marginRight: '0rem',

                                  // padding: '16px',
                                  // marginLeft: '-4rem',
                                }}
                              >
                                <Box
                                  sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    // height: '84px',
                                    // width: '119px',
                                    padding: '16px',
                                    gap: '16px',
                                  }}
                                >
                                  <a
                                    href={`${
                                      linkValue?.startsWith('http://') ||
                                      linkValue?.startsWith('https://')
                                        ? ''
                                        : 'https://'
                                    }${linkValue}`}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                    style={{
                                      textDecoration: 'none',
                                      display: 'flex',
                                      gap: '9px',
                                      cursor: !linkPost[
                                        Object.keys(linkPost)[0] as keyof typeof linkPost
                                      ]
                                        ? 'auto'
                                        : 'pointer',
                                    }}
                                    onClick={(e) =>
                                      !linkPost[
                                        Object.keys(linkPost)[0] as keyof typeof linkPost
                                      ] && e.preventDefault()
                                    }
                                  >
                                    <img src={'/assets/eye-open.svg'} width={18} height={18} />
                                    <Typography
                                      variant='body3'
                                      color={
                                        !linkPost[Object.keys(linkPost)[0] as keyof typeof linkPost]
                                          ? zeplinColor?.Neutral8
                                          : zeplinColor.BasicBlack
                                      }
                                    >
                                      Open Link
                                    </Typography>
                                  </a>
                                  <Box
                                    sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}
                                    onClick={() => {
                                      setLinkField(true);
                                      // setTimeout(() => {
                                      //   linkInputRef.current?.scrollIntoView({
                                      //     behavior: 'smooth',
                                      //     block: 'end',
                                      //   });
                                      // }, 0);
                                      setTimeout(() => {
                                        if (linkInputRef?.current) {
                                          linkInputRef.current.scrollTop =
                                            linkInputRef.current.scrollHeight; // Scroll to the bottom
                                        }
                                      }, 0);
                                      setAnchorElLink(null);
                                    }}
                                  >
                                    <img src={'/assets/edit.svg'} width={18} height={18} />
                                    <Typography variant='body3' color={zeplinColor.BasicBlack}>
                                      Edit Link
                                    </Typography>
                                  </Box>
                                  {customLinkIdx?.current != null && (
                                    <Box
                                      sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}
                                      onClick={() => {
                                        handleDeleteCustomLink();
                                      }}
                                    >
                                      <img src={'/assets/delete.svg'} width={18} height={18} />
                                      <Typography variant='body3' color={zeplinColor.BasicBlack}>
                                        Delete Link
                                      </Typography>
                                    </Box>
                                  )}
                                </Box>
                              </CustomPopOver>
                            </Box>
                          </Box>
                        </Box>
                      ) : (
                        <LoginReset user={userEmail} />
                      )}
                    </CustomCard>
                  </Box>
                </Box>
              </Box>
              <CustomAlert
                open={alert ? true : false}
                handleClose={() => {
                  setAlert('');
                }}
                message={
                  <CustomAlertContain
                    alert={alert}
                    error={alert?.includes('successfully') ? false : true}
                    alertIcon={
                      !alert || alert?.includes('successfully') ? (
                        <img src='/assets/checkmark-green.png' width={24} height={24} />
                      ) : (
                        <img src='/assets/error.svg' width={24} height={24} />
                      )
                    }
                  />
                }
                error={alert && !alert?.includes('successfully') ? true : false}
              />
            </CustomCard>
          </Box>
        </CustomModal>
      </Box>
      <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }} />
    </>
  );
};

export default Header;
